import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const POLICY_ROUTES = [
  "/cancellation-policy",
  "/terms-of-service",
  "/privacy-policy",
];

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    // In-page anchor: scroll to element instead of top
    if (hash) {
      const id = hash.slice(1);
      // Defer so the target section is mounted (esp. after route change)
      requestAnimationFrame(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
      prevPathname.current = pathname;
      return;
    }

    const prev = prevPathname.current;
    prevPathname.current = pathname;

    const movingBetweenPolicies =
      POLICY_ROUTES.includes(pathname) && POLICY_ROUTES.includes(prev);

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    window.scrollTo({
      top: 0,
      left: 0,
      behavior:
        movingBetweenPolicies && !prefersReducedMotion ? "smooth" : "auto",
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;

